import { publicApi } from './index';

export const physicalApi = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    createPhysicalGiftCardOrder: builder.mutation({
      query: ({
        email,
        amount,
        country,
        zipCode,
        state,
        street,
        projectURL,
        telegram,
        tokensPerCard,
      }) => ({
        url: '/physical',
        method: 'POST',
        body: {
          email,
          amount,
          country,
          zipCode,
          state,
          street,
          projectURL,
          telegram,
          tokensPerCard,
        },
      }),
    }),
  }),
});

export const { useCreatePhysicalGiftCardOrderMutation } = physicalApi;
